import { IProps } from './index'

const CheckMeO2Ppg = ({ onConnect, onCancel }: IProps) => {
  return (
    <div
      className="reader-view"
      data-reader-view="device-instructions"
      data-device-type="checkmeo2-ppg"
    >
      <h3 className="mb-6">
        <i className="fa fa-info-circle"></i>
        Instructions for clearing the oximeter's data
      </h3>

      <ul className="text-left">
        <li>
          <span>1</span> Connect your CheckMeO2 device to your computer using the USB cable
        </li>
        <li>
          <span>2</span> Make sure the device is not currently recording any data
        </li>
        <li>
          <span>3</span> The device should be in standby mode, not actively measuring
        </li>
        <li className="warning">
          <span>4</span> <small>IMPORTANT:</small> This will permanently delete all recorded data and reset all device settings to factory defaults
        </li>
      </ul>

      <div className="flex justify-center items-center space-x-2 my-6">
        <button className="btn btn-default" onClick={onCancel}>
          <i className="fa fa-reply"></i>
          Reset Another Device
        </button>
        <button className="btn btn-primary" onClick={onConnect}>
          <i className="fa fa-download"></i>
          Reset Oximeter
        </button>
      </div>
    </div>
  )
}

export default CheckMeO2Ppg
